import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import PollOption from "./pollOption";
import { useAppDispatch, useAppSelector } from "redux-share/hooks";
import { conditions, handleSumVotes, isVoted, livePoll, seenPoll } from "helpers";
import { ConditionName, zIndex } from "interfaces";
import { setClearPopoversSlice } from "redux-share/slices/popoversSlice";
import { setSelectedOptionId } from "redux-share/slices/videoDataSlice";
import { pollModalCloseLog, sendFluentLog } from "../../../../../logs";
import IMAGES from "../../../../../images/importImages";
import { shallowEqual } from 'react-redux';
import dynamic from "next/dynamic";

const MessageIcon = dynamic(() => import("../../icon-components/MessageIcon"));
const CloseIcon = dynamic(() => import("../../icon-components/closeIcon"));

const Poll = () => {

    const { question, params, details } = useAppSelector(({ videoData: { question, params, details, isComplexPortrait } }) => ({ question, params, details, isComplexPortrait }), shallowEqual);

    const [sumVotes, setSumVotes] = useState<number>(handleSumVotes(question));
    const [pollsSlideArrow, setPollsSlideArrow] = useState<boolean>(false);
    const [pollSlideScrollLeft, setPollSlideScrollLeft] = useState<number>(0);
    const [showPollPopover, setShowPollPopover] = useState<boolean>(false)

    const pollsContainerRef = useRef<any>();

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (conditions(ConditionName.hasPoll)) {
            setSumVotes(handleSumVotes(question));
            if (!seenPoll() || (seenPoll() && +seenPoll() !== question.id)) {
                if (conditions(ConditionName.isComplexPortrait)) dispatch(setClearPopoversSlice());
                setShowPollPopover(true);
            }
        } else {
            if (conditions(ConditionName.isComplexPortrait)) dispatch(setClearPopoversSlice());
            setShowPollPopover(true);
        }
    }, [question])


    const handleClickOption = (id: number, vote: number) => {
        dispatch(setSelectedOptionId(id));
        // State 2
        if (question || question.active) {
            if ((!!livePoll() && livePoll().liveId !== params.id) || !livePoll()) {
                localStorage.setItem("live-poll", JSON.stringify({
                    liveId: params.id,
                    polls: [{ qid: question.id, oid: id, sumOptionVotes: vote + 1 }]
                }));
            } else {
                if (livePoll().polls.filter((poll: any) => poll.qid === question.id).length === 0 && question.can_vote) {
                    localStorage.setItem("live-poll", JSON.stringify({
                        liveId: params.id,
                        polls: [...livePoll().polls, { qid: question.id, oid: id, sumOptionVotes: vote + 1 }]
                    }));
                }
            }
        }
    }

    const handleNextPoll = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        pollsContainerRef.current.scrollLeft -= pollsContainerRef.current.clientWidth;
    }

    const handlePrevPoll = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        pollsContainerRef.current.scrollLeft += pollsContainerRef.current.clientWidth;
    }

    useEffect(() => {
        if (pollsContainerRef.current) {
            const clientWidth = pollsContainerRef.current.clientWidth;
            const scrollWidth = pollsContainerRef.current.scrollWidth;
            setPollsSlideArrow(scrollWidth > clientWidth);
            setPollSlideScrollLeft(pollsContainerRef.current.scrollLeft);
            pollsContainerRef.current.addEventListener('scroll', (e: any) => setPollSlideScrollLeft(e.target.scrollLeft));
        }
        return () => pollsContainerRef.current && pollsContainerRef.current.removeEventListener('scroll', () => true);

    }, [pollsContainerRef.current, question]);

    const handleClose = () => {
        setShowPollPopover(false);
        localStorage.setItem("seen-poll", question.id);
        sendFluentLog(pollModalCloseLog(params, details, question.id));
    }

    return (
        <>
            {question && Object.keys(question).length > 0 && question.active && showPollPopover && (
                <div className={`pl-w-full pl-mx-auto pl-flex pl-flex-col pl-absolute ${conditions(ConditionName.isTouchScreenPortrait) ? "pl-top-12" : "pl-top-3"} animate__animated ${showPollPopover && "animate__fadeInDown"} pl-opacity-100`} style={{ zIndex: zIndex.poll }}>
                    <div className={`pl-mx-auto ${conditions(ConditionName.isTouchScreenLandscape) && "pl-w-[65vw]"} ${conditions(ConditionName.isTouchScreenPortrait) && "pl-w-[92vw] !pl-mx-0"} lg:pl-w-[40%] pl-bg-white dark:pl-bg-gray-800/[0.7] pl-px-[17px] pl-py-[14px] pl-rounded-[12px] pl-relative`}>
                        <div className="pl-flex pl-gap-2 pl-items-center pl-mb-2">
                            <MessageIcon className="pl-stroke-gray-800 dark:pl-stroke-dark-5" />
                            <p className={`pl-text-[12px] pl-break-all pl-font-normal pl-text-gray-800 dark:pl-text-white pl-flex-1`}>{question.text}</p>
                            <CloseIcon className="pl-cursor-pointer pl-w-4 pl-h-4 pl-stroke-gray-800 dark:pl-stroke-dark-5" onClick={handleClose} />
                        </div>
                        {question.options && question.options.length > 0 && (
                            <>
                                <div className="pl-max-h-[200px] pl-overflow-auto no-scrollbar" ref={pollsContainerRef}>

                                    {
                                        pollsSlideArrow && !conditions(ConditionName.isTouchScreen) && (
                                            <>
                                                {
                                                    pollSlideScrollLeft < 0 && (
                                                        <div className={`pl-flex pl-items-center pl-justify-center pl-cursor-pointer pl-transition hover:pl-scale-[1.2] pl-drop-shadow-lg pl-absolute pl-rounded-full ${isVoted(question.id) ? "pl-mt-[15px]" : "pl-mt-[13px]"}`} onClick={handlePrevPoll}>
                                                            <Image src={IMAGES.chevronCircleRight} width={18} height={18} alt="chevronCircleRight-icon" />
                                                        </div>
                                                    )
                                                }
                                                {
                                                    Math.abs(pollSlideScrollLeft - pollsContainerRef.current.clientWidth) !== pollsContainerRef.current.scrollWidth - 1 && (
                                                        <div className={`pl-flex pl-items-center pl-justify-center pl-cursor-pointer pl-transition hover:pl-scale-[1.2] -pl-rotate-180 pl-drop-shadow-lg pl-absolute pl-left-2 pl-rounded-full ${isVoted(question.id) ? "pl-mt-[15px]" : "pl-mt-[13px]"}`} onClick={handleNextPoll}>
                                                            <Image src={IMAGES.chevronCircleRight} width={18} height={18} alt="chevronCircleRight-icon" />
                                                        </div>
                                                    )
                                                }
                                            </>
                                        )
                                    }

                                    <div className="pl-flex pl-gap-2">
                                        {question.options.map((option: any) => (
                                            <PollOption
                                                option={option}
                                                key={option.id}
                                                lastOptionId={question.options.find((item: any) => item.vote === Math.max(...question.options.map((o: any) => o.vote))).id}
                                                sumVotes={sumVotes}
                                                onClick={() => (question.can_vote && !isVoted(question.id)) && handleClickOption(option.id, option.vote)}
                                            />
                                        ))}
                                    </div>
                                </div>
                                {isVoted(question.id) && (
                                    <p className="pl-flex pl-gap-1 pl-text-[11px] pl-mt-1">
                                        <span>تعداد کل آرا:</span>
                                        <span>{handleSumVotes(question)} نفر</span>
                                    </p>
                                )}
                            </>

                        )}
                    </div>
                </div>
            )}
        </>
    )
}

export default Poll;